import { Component, OnInit } from '@angular/core';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { Platform, NavController, MenuController } from '@ionic/angular';


@Component({
  selector: 'app-howtouse',
  templateUrl: './howtouse.page.html',
  styleUrls: ['./howtouse.page.scss'],
})
export class HowtousePage implements OnInit {
  langcontext: any;
  counter =1;
  mainoverlay=true;  
  show = true;
  shortcutsscreen=false;
  shortcutsscreen2=false;
  stareedscreen=false;
  addresscard=false;
  capsule=false;
  role: any;
  clickType: any;
  constructor(public platform: Platform,public cmndef: CommonDefinitionService,public cmndecl: CommonDeclarationService,public menuCtrl: MenuController, public api: RestapiService,public navCtrl: NavController) {
   // this.platform.ready().then(()=>{
    this.role = localStorage.role
    if (this.cmndecl.LanguageJson) {
      this.langcontext = this.cmndecl.LanguageJson.pages[0]['overlyScreen'];
      console.log( this.langcontext);
    } else {
      this.cmndecl.LanguageJson = JSON.parse(localStorage.languageJson);
      this.langcontext = this.cmndecl.LanguageJson['pages'][0].overlyScreen;
      console.log( this.langcontext);
    }

    if(this.role == "new")
    this.clickType = ""
    else
    this.clickType = "B"
   }

  ionViewWillEnter () {
    this.menuCtrl.swipeEnable(false);
  }

  ngOnInit() {
  }


  showNext(){
    this.counter++;
    console.log(this.counter);
    if(this.counter == 1){
      this.show = true; 
    }else if (this.counter == 2) {
      this.show = false; 
      this.shortcutsscreen=true;  
  } else if(this.counter == 3){
      this.shortcutsscreen = false; 
      this.shortcutsscreen2=true; 
  }else if(this.counter == 4){
      this.shortcutsscreen2 = false; 
      this.stareedscreen=true; 
  }else if(this.counter == 5){
      this.stareedscreen=false;   
      this.addresscard=false;
      this.capsule=true;
  }else{
    this.show = false;
    this.mainoverlay=false; 
    this.counter=1;
    this.cmndecl.howtouse = false;  
    this.show = true;
    this.mainoverlay=true; 
    this.shortcutsscreen = false; 
    this.shortcutsscreen2 = false; 
    this.stareedscreen=false; 
    this.addresscard=false;
    this.capsule=false;
  }
}
}
